import { render, staticRenderFns } from "./EmployeeSearch.vue?vue&type=template&id=406d47eb&scoped=true&"
import script from "./EmployeeSearch.vue?vue&type=script&setup=true&lang=js&"
export * from "./EmployeeSearch.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EmployeeSearch.vue?vue&type=style&index=0&id=406d47eb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406d47eb",
  null
  
)

export default component.exports